import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { PageWrapper } from "components/ui/PageWrapper";
import { PartnerServiceForm } from "components/PartnerService-form";
import { AddPartnerService as AddPartnerServiceMutation } from "rest/partnerServices";

import "styles/main.css";

export default function AddPartnerService() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
    control,
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
      items: [""],
      icon: "",
      linkText: "View more",
      linkUrl: "",
      displayOrder: 1,
      status: "active",
      contentType: "items"
    }
  });

  const addPartnerServiceMutation = AddPartnerServiceMutation();

  const onSubmit = (data) => {
    const { description, items: rawItems, contentType: formContentType, linkText, linkUrl, displayOrder } = data;

    let items = [];
    if (rawItems) {
      try {
        const parsed = typeof rawItems === 'string' ? JSON.parse(rawItems) : rawItems;
        if (Array.isArray(parsed)) {
          items = parsed.filter(item => item && item.trim());
        }
      } catch (e) {
        items = [];
      }
    }

    const hasDescription = description && description.trim().length > 0;
    const contentType = formContentType === 'description' || (hasDescription && formContentType !== 'items') ? 'description' : 'items';

    const submitData = {
      title: data.title,
      icon: data.icon,
      status: data.status,
      link_text: linkText,
      link_url: linkUrl,
      display_order: displayOrder,
      content_type: contentType,
      content: contentType === 'description' ? description.trim() : items,
    };

    addPartnerServiceMutation.mutate(submitData, {
      onSuccess: (response) => {
        if (response?.status === "success") {
          reset();
          setTimeout(() => {
            navigate("/partner-services");
          }, 1500);
        }
      }
    });
  };

  return (
    <div className="partner-service-page">
      <PageWrapper 
        slug="services" 
        name="Services"
        breadcrumbItems={[
          { label: "Dashboard", link: "/" },
          { label: "Services", link: "/partner-services" },
          { label: "Add New", link: "/add-partner-service" }
        ]}
      />
      
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="page-title">Add New Service</h4>
          <button 
            type="button"
            onClick={() => navigate("/partner-services")}
            className="btn btn-primary"
            style={{ 
              backgroundColor: "#2a3071",
              borderColor: "#2a3071"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#34caff";
              e.target.style.borderColor = "#34caff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#2a3071";
              e.target.style.borderColor = "#2a3071";
            }}
          >
            Back to List
          </button>
        </div>

        <div className="card">
          <div className="card-body">
            <PartnerServiceForm
              onSubmit={handleSubmit(onSubmit)}
              register={register}
              errors={errors}
              setValue={setValue}
              watch={watch}
              control={control}
              isLoading={addPartnerServiceMutation?.isPending}
            />
          </div>
        </div>
      </div>
    </div>
  );
}